import store from '@/store';

const requireAdminAccess = (_to: any, _from: any, next: any) => {
  const roles = (store.getters.user?.roles ?? []) as string[];

  if (roles.includes('ADMIN') || roles.includes('BLOG_ADMIN')) {
    next();
    return;
  }

  next({ name: 'home' });
};

export default requireAdminAccess;
